import React, {FunctionComponent} from "react"
import {useNavigate} from "react-router"
// icons
import {IconContext} from "react-icons/lib"
import {IoChevronBackOutline, IoChevronForwardOutline} from "react-icons/io5"
import Button from "@murphy-frontend/web-core/components/Button"

interface BottomNavigationProps {
	prevBlock: number
	nextBlock: number
	customerId: string
	searchQuery: string
	translations: Record<any, any>
	isSurvey: boolean
	handleNext: (next: number) => void
}

const BottomNavigation: FunctionComponent<BottomNavigationProps> = ({
	prevBlock,
	customerId,
	searchQuery,
	translations,
	nextBlock,
	isSurvey,
	handleNext
}) => {
	const navigate = useNavigate()

	if (!isSurvey)
		return <></>

	return (
		<section className='general-wrapper'>
			<div className='header-right-btn'>
				<Button
					buttonSize={"btn--medium"}
					isLightButton={true}
					disabled={prevBlock === -1}
					onClick={() => navigate(`/questionnaire/${customerId}/${prevBlock}${searchQuery}`)}
				>
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronBackOutline />
					</IconContext.Provider>
					{translations.prevBox || "Previous"}
				</Button>
				<Button
					buttonSize={"btn--medium"}
					isLightButton={true}
					disabled={nextBlock === -1 && !isSurvey}
					onClick={() => handleNext(nextBlock)}
				>
					{translations.nextBox || "Next"}
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronForwardOutline />
					</IconContext.Provider>
				</Button>
			</div>
		</section>
	)
}

export default BottomNavigation
